import { Pipe, PipeTransform } from '@angular/core';
import { PostBoxDocument } from '@zero/postbox/domain';
import { Post } from '@zero/shared/util-models';

@Pipe({
  name: 'postTitle',
  standalone: true,
})
export class PostTitlePipe implements PipeTransform {
  public transform(value: PostBoxDocument | Post): string {
    return getDocumentTitle(value);
  }
}

export const getDocumentTitle = (document: PostBoxDocument | Post): string => {
  if (document.pdfTitle) {
    let ret = document.pdfTitle;
    if (document.pdfIsin) {
      const isins = document.pdfIsin.split(',');
      if (isins.length > 2) {
        ret += ` ${isins[0]}, ${isins[1]}, ...`;
      } else {
        ret += ` ${isins.join(', ')}`;
      }
    }
    return ret;
  }

  return document.title;
};
